var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M27.263,27.269H22.524V19.844c0-1.771-.036-4.049-2.469-4.049-2.471,0-2.848,1.927-2.848,3.919v7.556H12.468V12H17.02v2.081h.061a4.994,4.994,0,0,1,4.493-2.467c4.8,0,5.689,3.16,5.689,7.273v8.381ZM7.116,9.911A2.752,2.752,0,1,1,9.868,7.157,2.749,2.749,0,0,1,7.116,9.911ZM9.492,27.269H4.74V12H9.492ZM29.633,0H2.361A2.333,2.333,0,0,0,0,2.305V29.695A2.332,2.332,0,0,0,2.361,32H29.629A2.341,2.341,0,0,0,32,29.695V2.305A2.342,2.342,0,0,0,29.629,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.86d71a8655b744b602219992ff56cdd4.svg";
export { ForwardRef as ReactComponent };